<form [formGroup]="userForm" class="example-form w-100 mb-2 pb-3 px-3" style="height:70vh; overflow-y: auto;" >
    
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.personForm.anzeigeName' | translate}}</mat-label>
            <input formControlName="displayName" matInput type="text" required>
        </mat-form-field>
    
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.userForm.email' | translate}}</mat-label>
            <input formControlName="email" matInput type="text" required>
        </mat-form-field>

        <div *ngIf="formCreate">
            <mat-form-field class="w-100">
                <mat-label>{{'FORM.userForm.password' | translate}}</mat-label>
                <input formControlName="password" matInput type="password" required [type]="hide ? 'password' : 'text'">
                <button mat-icon-button type="button" matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                    <mat-icon>{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
                </button>
            </mat-form-field>    
        </div>


    <div *ngIf="invitationAccepted || noInivited"> <!-- invitationState == 'accepted'-->
        <div class="mb-2">
            <div>
                <mat-form-field class="w-50 pr-1">
                    <mat-label>{{'FORM.personForm.vorname' | translate}}</mat-label>
                    <input formControlName="firstName" matInput type="text" required>
                </mat-form-field>
            
                <mat-form-field class="w-50 pl-1">
                    <mat-label>{{'FORM.personForm.nachname' | translate}}</mat-label>
                    <input formControlName="lastName" matInput type="text" required>
                </mat-form-field>
            </div>
        
            <div class="row justify-content-between w-100">
                <div class="col"> {{'FORM.personForm.geschlecht' | translate}} </div>
                <div class="col">
                    <mat-radio-group formControlName="gender" aria-label="Select an option">
                        <mat-radio-button value="m" [disabled] = "disabledEditdata">{{'FORM.personForm.genderMale' | translate}}</mat-radio-button>
                        <mat-radio-button value="f" [disabled] = "disabledEditdata">{{'FORM.personForm.genderFemale' | translate}}</mat-radio-button>
                        <mat-radio-button value="d" [disabled] = "disabledEditdata">{{'FORM.personForm.genderDiverse' | translate}}</mat-radio-button>
                    </mat-radio-group> 
                </div>
            </div>
        
            <mat-form-field class="w-100">
                <mat-label>{{'FORM.userForm.salutation' | translate}}</mat-label>
                <input formControlName="salutation" matInput type="text" >
            </mat-form-field>
        
            <mat-form-field class="w-100">
                <mat-label>{{'FORM.userForm.title' | translate}}</mat-label>
                <input formControlName="title" matInput type="text">
            </mat-form-field>
        </div>
    
    
        <div class="w-100">
            <span class="text-muted text-uppercase"> {{'FORM.userForm.legalAdress' | translate}} </span>
            <div > 
                <mat-form-field class="w-100">
                    <mat-label>{{'FORM.userForm.address1' | translate}}</mat-label>
                    <input formControlName="address1" matInput type="text">
                </mat-form-field>

                <mat-form-field class="w-100">
                    <mat-label>{{'FORM.userForm.address2' | translate}}</mat-label>
                    <input formControlName="address2" matInput type="text">
                </mat-form-field>

                <div>
                    <mat-form-field class="w-50 pr-1">
                        <mat-label>{{'FORM.personForm.zip' | translate}}</mat-label>
                        <input #postalCode formControlName="zip" matInput maxlength="5" type="text">
                        <mat-hint align="end">{{postalCode.value.length}} / 5</mat-hint>
                    </mat-form-field>
    
                    <mat-form-field class="w-50 pl-1">
                        <mat-label>{{'FORM.personForm.city' | translate}}</mat-label>
                        <input formControlName="city" matInput type="text">
                    </mat-form-field>
                </div>

                <mat-form-field class="w-100">
                    <mat-label>{{'FORM.personForm.country' | translate}}</mat-label>
                    <mat-select formControlName="countryCode" >
                        <mat-option *ngFor="let co of allCountries" [value]="co.isoCode"> {{co.translate | translate}} </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
       
        <mat-form-field class="w-100">
            <mat-label>{{'FORM.userForm.telephone' | translate}}</mat-label>
            <input type="tel" formControlName="telephone" matInput >
        </mat-form-field>
    </div>
    

    <div *ngIf="ownUser">
        <mat-form-field *ngIf="!data.data && !newDistrictSignature" class="w-100">
            <mat-label>{{'FORM.userForm.signature' | translate}}</mat-label>
            <input formControlName="signature" matInput type="text" [value]="" style="display:none; ">
            <button class="spanw" style="margin-top:25px;" mat-raised-button type="button" (click)="openSignaturePad()" color="accent">{{'FORM.huntingDistrictForm.createSignature' | translate}}</button>
        </mat-form-field>
    
        <mat-form-field *ngIf="!data.data && newDistrictSignature" class="d-flex flex-column pt-2 w-100">
            <mat-label>{{'FORM.userForm.signature' | translate}}</mat-label>
            <input formControlName="signature" matInput type="text" [value]="newDistrictSignature" style="display:none; " >
    
            <div style="border:1px solid #000; margin-top:10px;">
                <img src="{{newDistrictSignature}}" alt="" style="max-height: 300px;" >
            </div>
            <button class="spanw" style="margin-top:2%;" mat-raised-button type="button" (click)="openSignaturePad()" color="accent">{{'FORM.huntingDistrictForm.changeSignature' | translate}}</button>
        </mat-form-field>
    
        <mat-form-field *ngIf="data.data && !data.data.signature && !userForm.value.signature" class="d-flex flex-column pt-2 w-100">
            <mat-label>{{'FORM.userForm.signature' | translate}}</mat-label>
            <input formControlName="signature" matInput type="text" [value]="" style="display:none; ">
            <button class="spanw" style="margin-top:25px;" mat-raised-button type="button" (click)="openSignaturePad()" color="accent">{{'FORM.huntingDistrictForm.createSignature' | translate}}</button>
        </mat-form-field>
    
        <mat-form-field *ngIf="data.data && !data.data.signature && userForm.value.signature" class="d-flex flex-column pt-2 w-100">
            <mat-label>4-{{'FORM.userForm.signature' | translate}}</mat-label>
            <input formControlName="signature" matInput type="text" [value]="userForm.value.signature" style="display:none; ">
            <div style="border:1px solid #000; margin-top:10px;">
                <img src="{{userForm.value.signature}}" alt="" style="max-height: 300px;">
            </div>
            <div>
                <button class="spanw" style="margin-top:10px;" mat-raised-button type="button" (click)="changeSignaturePad()" color="accent">{{'FORM.huntingDistrictForm.changeSignature' | translate}}</button>
                <!-- <button class="spanw" style="margin-top:2%;" mat-raised-button type="button" (click)="deleteSignature()" color="warn">{{'FORM.huntingDistrictForm.deleteSignature' | translate}}</button>     -->
            </div>

        </mat-form-field>

        <mat-form-field *ngIf="data.data &&  data.data.signature  && !userForm.value.signature" class="d-flex flex-column pt-2 w-100">
            <mat-label>5-{{'FORM.userForm.signature' | translate}}</mat-label>
            <input formControlName="signature" matInput type="text" [value]="data.data.signature" style="display:none; ">
            <div style="border:1px solid #000; margin-top:10px;">
                <img src="{{userForm.value.signature}}" alt="" style="max-height: 300px;" >
            </div>

            <button class="spanw" style="margin-top:10px;" mat-raised-button type="button" (click)="openSignaturePad()" color="accent">{{'FORM.huntingDistrictForm.createSignature' | translate}}</button>    
        </mat-form-field>
        
        <mat-form-field *ngIf="data.data && data.data.signature && userForm.value.signature" class="d-flex flex-column pt-2 w-100">
            <mat-label>{{'FORM.userForm.signature' | translate}}</mat-label>
            <input formControlName="signature" matInput type="text" [value]="data.data.signature" style="display:none; ">
    
            <div style="border:1px solid #000; margin-top:10px;">
                <img src="{{userForm.value.signature}}" alt="" style="max-height: 300px;">
            </div>
            <button class="spanw" style="margin-top:10px;" mat-raised-button type="button" (click)="changeSignaturePad()" color="accent">{{'FORM.huntingDistrictForm.changeSignature' | translate}}</button>
            <!-- <button class="spanw" style="margin-top:2%;" mat-raised-button type="button" (click)="deleteSignature()" color="warn">{{'FORM.huntingDistrictForm.deleteSignature' | translate}}</button>     -->
        </mat-form-field> 
    </div>

    <!-- Supercontext-only: same visual pattern as app-context-rights-picker (WorkOrder/POI) -->
    <mat-accordion class="context-rights" *ngIf="roleContextOptions.length">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header collapsedHeight="48px" expandedHeight="48px">
                <mat-panel-title>
                    <mat-icon class="cr-icon">lock_person</mat-icon>
                    <span>{{'FORM.userForm.contextRolesSection' | translate}}</span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="cr-list">
                <div class="cr-row" *ngFor="let ctx of memberContexts">
                    <mat-checkbox class="cr-check" [checked]="isContextIncluded(ctx.id)" [disabled]="ctx.id === data.data?.contextId"
                        (change)="onContextIncludedChange(ctx.id, $event.checked)">
                        <span class="cr-name" [matTooltip]="ctx.name">{{ ctx.name }}</span>
                    </mat-checkbox>

                    <mat-form-field appearance="outline" subscriptSizing="dynamic" class="cr-right">
                        <mat-select [value]="ctx.roles" (selectionChange)="onRowRolesChange(ctx, $event.value)" multiple placeholder="{{'COCKPIT.SETTINGS.userRoles' | translate}}">
                            <mat-option *ngFor="let r of roleOptions; trackBy: trackByIdentifier" [value]="r.identifier">{{ r.title }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <span class="ps-2 text-muted small d-block" *ngIf="!contextMembership && selectedContextId !== data.data?.contextId">
                {{'FORM.userForm.saving_adds_to_context' | translate}}
            </span>

            <button mat-stroked-button type="button" color="primary" class="add-context-btn" *ngIf="addableContexts.length" [matMenuTriggerFor]="addContextMenu">
                <mat-icon>add</mat-icon> {{'FORM.userForm.addContext' | translate}}
            </button>
            <mat-menu #addContextMenu="matMenu">
                <button mat-menu-item type="button" *ngFor="let ctx of addableContexts" (click)="addRoleContext(ctx.id)">{{ ctx.name }}</button>
            </mat-menu>

            <span class="ps-2 text-muted small d-block">{{'FORM.userForm.roleRecorder_info' | translate}}</span>
        </mat-expansion-panel>
    </mat-accordion>

    <!-- Plain single-context case: just the roles, no context picker -->
    <div class="w-100 roles-select-block" *ngIf="!roleContextOptions.length">
        <span class="text-muted text-uppercase">{{'COCKPIT.SETTINGS.userRoles' | translate}}</span>

        <mat-form-field class="w-100 mt-3" appearance="outline">
            <mat-label>{{'COCKPIT.SETTINGS.userRoles' | translate}}</mat-label>
            <mat-select [formControl]="rolesSelectCtrl" multiple>

                <mat-select-trigger> {{ selectedOptionRoles() }} </mat-select-trigger>

                <ng-container *ngFor="let r of roleOptions; trackBy: trackByIdentifier" >

                    <mat-option *ngIf="!r.disabled" [value]="r.identifier"> {{ r.title }} </mat-option>

                    <!-- Hidden options that are selected, support other roles -->
                    <mat-option *ngIf="r.disabled && roleIsSelected(r.identifier)" class="hidden-role-option" [value]="r.identifier">
                        {{ r.title }}
                    </mat-option>
                </ng-container>

            </mat-select>
        </mat-form-field>

        <span class="ps-2 text-muted small">{{'FORM.userForm.roleRecorder_info' | translate}}</span>
    </div>

    <!-- Only on diwima-adis module  -->
    <div class="w-100 mt-4" *ngIf="showNotificationPreferences">
        <span class="text-muted text-uppercase">{{'FORM.userForm.notification_preferences' | translate}}</span>
        <div class="notif-event-row" *ngFor="let event of notificationEvents">
            <span class="notif-event-label">{{ event.labelKey | translate }}</span>
            <mat-slide-toggle class="example-margin slide-toggle-text" [formControlName]="mailControlName(event)">
                {{'FORM.userForm.channel_email' | translate}}
            </mat-slide-toggle>
            <mat-slide-toggle class="example-margin slide-toggle-text" [formControlName]="pushControlName(event)">
                {{'FORM.userForm.channel_push' | translate}}
            </mat-slide-toggle>
        </div>
    </div>

</form>

<div class="sticky-bottom dialog-footer">
    <button [disabled]="userForm.invalid || submitted" class="second-btn delete-btn" mat-button type="button" (click)="onDelete()">
        <mat-icon>delete</mat-icon>
        {{ 'FORM.BTN_DELETE' | translate }}
    </button>

    <span class="footer-spacer"></span>

    <button *ngIf="invitationState && invitationState !='accepted'" class="first-btn" mat-button (click)="sendInvitationAgain()">
        {{ 'btn_resend_invitation' | translate }}
    </button>

    <button class="second-btn" mat-button type="button" (click)="onCancle()">
        {{ 'cancel' | translate }}
    </button>

    <button *ngIf="!disabledEditdata" [disabled]="userForm.invalid || submitted || disabledEditdata" class="first-btn" mat-button type="submit" (click)="onSubmit()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>

    <button *ngIf="disabledEditdata" [disabled]="userForm.invalid || submitted" class="first-btn" mat-button type="submit" (click)="submitData()">
        {{ 'FORM.BTN_SAVE' | translate }}
    </button>
</div>
